<template>
    <div>
        <common-notification ref="commonSuccessNotification" :content="notificationMessage"></common-notification>

        <div>
            <div class="referral-tracking__referrals-made-card">
                <div class="referral-tracking__referrals-filter-row">
                    <div class="filter-left">
                        <span class="filter-icon">
                            <common-icon name="filter" size="small"></common-icon>
                        </span>
                        <span>{{ $t('pages.referrals.index.referrals_made.filters') }}</span>
                        <span class="ref-count">
                            {{ $t('pages.referrals.index.referrals_made.request_filters', { n: patientRequestsTotalCount }) }}
                        </span>
                    </div>

                    <!-- <div class="print-icon">
                        <common-icon name="print" size="small"></common-icon>
                    </div> -->
                </div>

                <div>
                    <table class="referral-tracking__referrals-made-table">
                        <thead>
                            <tr>
                                <th>{{ $t('pages.referrals.index.referrals_made.pataint') }}</th>
                                <th v-if="!isTablet">{{ $t('pages.referrals.index.referrals_made.pataint_for') }}</th>
                                <th v-if="!isMobile">{{ $t('pages.referrals.index.referrals_made.stage') }}</th>
                                <th v-if="!isTablet">{{ $t('pages.referrals.index.headings.status') }}</th>
                                <th v-if="!isTablet">{{ $t('pages.referrals.index.referrals_made.timing') }}</th>
                                <th v-if="!isTablet">{{ $t('pages.referrals.index.referrals_made.typer') }}</th>
                                <th>{{ $t('pages.referrals.index.referrals_made.action') }}</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="request in patientRequests">
                                <td class="referral-tracking__card-referral-layout">
                                    <div class="user-cell">
                                        <div class="user-avatar">
                                            <common-user-avatar size="" :user="request?.patient"></common-user-avatar>
                                        </div>
                                        <div>
                                            <p class="name">{{ getUserFullName(request.patient) }}</p>
                                            <p class="sub">
                                                {{ $t('pages.referrals.index.referrals_made.dob') }}
                                                {{ getPatientDateOfBirth(request.patient.dateOfBirth) }}
                                            </p>
                                            <p class="sub">
                                                <span class="referral-tracking__name">
                                                    {{ request?.insurancePlan?.name }}
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </td>

                                <td v-if="!isTablet">
                                    <p class="referral-tracking__name">{{ getAppointmentDateTime(request) }}</p>
                                    <p v-if="request?.appointmentDateTime" class="sub">{{ request?.practiceLocation.name }}</p>
                                </td>

                                <td v-if="!isMobile">
                                    <div class="referral-tracking__stage">
                                        <span :class="getStageClasses(request)" @click="handleStageAction(request)">
                                            {{ formatStage(request?.stageInfo?.stage) }}
                                        </span>

                                        <div class="referral-tracking__stage-tooltip-wrapper">
                                            <common-icon
                                                name="info"
                                                size="semi-small"
                                                class="referral-tracking__stage-info-icon"
                                            ></common-icon>

                                            <div class="referral-tracking__stage-tooltip">
                                                {{ getStageTooltip(request) }}
                                            </div>
                                        </div>
                                    </div>
                                </td>

                                <td v-if="!isTablet">
                                    <div class="referral-tracking__status-cell">
                                        <span :class="getStatusBadgeClass(request)" @click="handleStatusAction(request)">
                                            <span class="referral-tracking__status-content">
                                                <span>{{ getStatusText(request) }}</span>
                                                <span v-if="request?.status !== ReferralStatusEnum.CONSULTATION_NOTES_PENDING">
                                                    {{ scheduledForDate(request.appointmentDateTime) }}
                                                </span>
                                            </span>
                                        </span>
                                        <div
                                            v-if="isStatusChangeable(request)"
                                            v-clickaway="closeStatusDropdown"
                                            class="referral-context-menu"
                                        >
                                            <span class="dots" @click.stop="handleStatusClick(request)">⋮</span>

                                            <div
                                                v-if="activeStatusDropdown === request.id"
                                                class="referral-context-menu__dropdown-menus referral-actions"
                                            >
                                                <span
                                                    v-for="option in dropdownOptions(request)"
                                                    :key="option"
                                                    class="referral-context-menu__menu-item referral-context-menu__with-status"
                                                    @click="handleStatusChange(request, option)"
                                                >
                                                    <span>
                                                        {{
                                                            $t(
                                                                `pages.referrals.tracking.status_title.${getDropdownOptionStatus(
                                                                    option,
                                                                    request.sourceType,
                                                                )}`,
                                                            )
                                                        }}
                                                    </span>
                                                    <span
                                                        class="referral-context-menu__status-dot"
                                                        :class="getDropdownStatusColor(option, request.sourceType)"
                                                    ></span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </td>

                                <td v-if="!isTablet">
                                    <span :class="getTimingClass(request?.stageInfo)">
                                        {{ getTimingText(request) }}
                                    </span>
                                </td>

                                <td v-if="!isTablet">
                                    <span class="referral-tracking__referrals" :class="requestTypeClass(request?.sourceType)">
                                        {{ getRequestType(request?.sourceType) }}
                                    </span>
                                </td>

                                <td class="referral-tracking__view-port">
                                    <div class="referral-tracking__confirt-detail">
                                        <button
                                            v-if="!isTablet"
                                            class="referral-tracking__view-details-btn"
                                            @click="openDetailsModal(request.id, request.sourceType)"
                                        >
                                            {{ $t('pages.referrals.index.referrals_made.detail') }}
                                        </button>
                                        <div>
                                            <referral-details-context-menu
                                                :referral="request"
                                                type="received"
                                                :isDisabled="false"
                                                @select-referral="selectedRequestForActions = $event"
                                                @open-details="openDetailsModal(request.id, request.sourceType)"
                                                @propose-slot="(data) => goToProposeTime(data, activeReferralTab)"
                                                @reschedule="openRescheduleModal(request)"
                                                @follow-up-visit="openFollowUpVisitModal(request)"
                                                @cancel="openCancellationModal"
                                                @match="matchReferral(request)"
                                                @patientSeen="openPatientSeenModal(request)"
                                                @addReport="addNotesClicked(request)"
                                                @downloadPdf="downloadPdf(request)"
                                                @requestReport="openRequestReportModal(request)"
                                                @external-decline="declineReferral(request)"
                                            ></referral-details-context-menu>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div>
            <referral-modal
                v-if="showViewDetailsModal"
                :showAsInnerModal="false"
                :referral="activeRequest"
                type="received"
                :sourceType="activeSourceType"
                :isOpen="showViewDetailsModal"
                :isFetching="isFetching"
                @open-direct-referral="openDirectReferralFromMatchReferal"
                @close="closeDetailsModal"
                @fetch-referral="refreshMatchReferral"
                @records-requested="showAdditionalRecordsRequestedNotification"
            ></referral-modal>
            <referrals-pool-providers-modal
                v-if="showReferralsPoolProvidersModal"
                :referralPoolId="activeReferralPoolId"
                @close="closeProvidersModal"
            ></referrals-pool-providers-modal>
            <pending-reschedule-modal
                v-if="showRescheduleModal"
                :referral="selectedRequestForActions"
                :followUpReferral="followUpReferral"
                @deny="
                    closeRescheduleModal()
                    openCancellationModal()
                "
                @reschedule="handleRescheduleAppointment"
                @close="closeRescheduleModal"
            ></pending-reschedule-modal>
            <referral-cancellation-modal
                v-if="showCancellationModal"
                :referral="selectedRequestForActions"
                :type="isReferringPhysician ? 'referring' : 'referred'"
                :withSecondOption="!isReferringPhysician || isReferralError(selectedRequestForActions)"
                @close="closeCancellationModal"
                @confirm="cancelAppointment"
                @deny="cancellationModalDenyAction"
            ></referral-cancellation-modal>
            <referrals-is-patient-seen-modal
                v-if="showPatientSeenModal"
                :referral="selectedRequestForActions"
                @patient-seen="patientSeen"
                @skip-all="showPatientSeenModal = false"
                @close="showPatientSeenModal = false"
            ></referrals-is-patient-seen-modal>
            <common-modal
                v-if="isPrescriptionModalOpen"
                :isOpen="isPrescriptionModalOpen"
                width="large"
                @close="closePrescriptionModal"
            >
                <referral-prescription :referral="selectedRequestForActions"></referral-prescription>
            </common-modal>
            <request-report-modal
                v-if="showRequestReportModal"
                :isOpen="showRequestReportModal"
                :referral="selectedRequestForActions"
                @close="closeRequestReportModal"
                @sent="requestReportSent"
            ></request-report-modal>
            <is-report-uploaded-modal
                v-if="isReportUploadModal"
                :isOpen="isReportUploadModal"
                :referral="selectedRequestForActions"
                @refresh-details="openDetailsModal(selectedRequestForActions.id, selectedRequestForActions.sourceType)"
                @close="isReportUploadModal = false"
            ></is-report-uploaded-modal>
        </div>
        <common-buttons class="referral-tracking__show-more">
            <common-button
                v-if="patientRequests.length < patientRequestsTotalCount"
                :isProcessing="isProcessing"
                :label="$t('pages.referrals.index.buttons.show_more')"
                type="primary"
                size="large"
                @click="showMore()"
            ></common-button>
        </common-buttons>
    </div>
</template>
<script>
    import dayjs from 'dayjs'
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import PageWithElementsMixin from 'mixins/PageWithElementsMixin'
    import PageWithDataMixin from 'mixins/PageWithDataMixin'
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'
    import ReferralModal from './ReferralModal.vue'
    import ReferralsAPI from 'api/ReferralsAPI'
    import ReferralsPoolAPI from 'api/ReferralsPoolAPI'
    import StagesEnum from '@/enums/StagesEnum'
    import UrgencyEnum from '@/enums/UrgencyEnum'
    import ReferralsPoolProvidersModal from 'components/page-elements/referrals/ReferralsPoolProvidersModal'
    import ReferralDetailsContextMenu from 'components/page-elements/ReferralDetailsContextMenu'
    import PendingRescheduleModal from 'components/page-elements/referrals-show-pending/PendingRescheduleModal'
    import ReferralCancellationModal from 'components/page-elements/ReferralCancellationModal'
    import ReferralRescheduleMixin from 'mixins/ReferralRescheduleMixin'
    import ReferralStatusMixin from 'mixins/ReferralStatusMixin'
    import ReferralPrescription from 'components/page-elements/referrals/ReferralPrescription'
    import RequestReportModal from 'components/page-elements/referrals/RequestConsultationReportModal'
    import ReferralTrackingTypeEnum from '@/enums/ReferralTrackingTypeEnum'
    import ScreenSizeDetectionMixin from 'mixins/ScreenSizeDetectionMixin'
    import IsReportUploadedModal from './IsReportUploadedModal.vue'
    import ReferralPathTypeEnum from '@/enums/ReferralPathTypeEnum'
    import ReferralStatusEnum from '@/enums/ReferralStatusEnum'
    import TimeWindowSearchCriteriaEnum from '@/enums/TimeWindowSearchCriteriaEnum'
    import ReferralPoolProposeNavigationMixin from 'mixins/ReferralPoolProposeNavigationMixin'

    export default {
        mixins: [
            PageWithTitleMixin,
            PageWithElementsMixin,
            PageWithDataMixin,
            ReferralRescheduleMixin,
            ReferralStatusMixin,
            ScreenSizeDetectionMixin,
            ReferralPoolProposeNavigationMixin,
        ],
        components: {
            ReferralModal,
            ReferralsPoolProvidersModal,
            ReferralDetailsContextMenu,
            PendingRescheduleModal,
            ReferralCancellationModal,
            ReferralPrescription,
            RequestReportModal,
            IsReportUploadedModal,
        },

        data() {
            return {
                ReferralStatusEnum,
                activeDropdown: null,
                activeMainTab: 'provider',
                activeReferralTab: 'received',
                activePatientTab: 'requests',
                showPatientDetailsModal: false,
                selectedRequestForActions: {},
                activeRequest: {},
                activeSourceType: null,
                PracticeTypeEnum: PracticeTypeEnum,
                practiceData: {},
                patientRequests: [],
                dropdownStates: {},
                actionStates: {},
                showReferralsPoolProvidersModal: false,
                showViewDetailsModal: false,
                isFetching: false,
                patientRequestsTotalCount: 0,
                limit: 10,
                offset: 0,
                isProcessing: false,
                showRescheduleModal: false,
                showCancellationModal: false,
                showPatientSeenModal: false,
                isPrescriptionModalOpen: false,
                showRequestReportModal: false,
                reportNewRequestDateTime: null,
                isReportUploadModal: false,
                followUpReferral: false,
                activeStatusDropdown: null,
                notificationMessage: '',
            }
        },
        provide() {
            return {
                isReferralPool: false,
            }
        },
        computed: {
            handleRescheduleAppointment() {
                return this.followUpReferral ? this.handleFollowUpVisit : this.rescheduleAppointment
            },
            requestTypeClass() {
                return (sourceType) => ({
                    referrals: true,
                    blue: sourceType === ReferralTrackingTypeEnum.DIRECT,
                    purple: sourceType === ReferralTrackingTypeEnum.MATCH,
                })
            },
            isReferringPhysician() {
                return this.activeReferralTab === ReferralPathTypeEnum.MADE
            },
        },
        methods: {
            toggleDropdown(index) {
                this.activeDropdown = this.activeDropdown === index ? null : index
            },

            closeDropdown() {
                this.activeDropdown = null
            },

            getDropdownPosition() {
                return {
                    position: 'absolute',
                    top: '80%',
                    right: '8px',
                    marginTop: '4px',
                    height: 'auto',
                    zIndex: 1000,
                }
            },
            getUserFullName(patient) {
                return patient ? `${patient.firstName} ${patient.lastName}` : 'N/A'
            },
            getPatientDateOfBirth(dob) {
                if (!dob) return 'N/A'

                const [year, month, day] = dob.split('-')
                return `${month}-${day}-${year}`
            },
            getRequestType(type) {
                if (type === 'referral') return this.$t('pages.referrals.index.referrals_made.type_direct')
                if (type === 'referrals_pool') return this.$t('pages.referrals.index.referrals_made.type_matched')
                return 'N/A'
            },
            getAppointmentDateTime(request) {
                if (!request.appointmentDateTime) {
                    if (request?.timeframe === 'custom') {
                        const [year, month, day] = request?.customDate.split('-')
                        return `${month}-${day}-${year}`
                    }
                    const timeframeLabel = TimeWindowSearchCriteriaEnum.find((item) => item.value === request?.timeframe)?.label

                    return timeframeLabel || request?.timeframe || 'TBD'
                }
                const date = new Date(request.appointmentDateTime)

                const formattedDate = date.toLocaleDateString('en-US', {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric',
                })

                const formattedTime = date.toLocaleTimeString('en-US', {
                    hour: 'numeric',
                    minute: '2-digit',
                    hour12: true,
                })

                return `${formattedDate} at ${formattedTime}`
            },
            getStageClass(stage) {
                if (!stage) return 'referral-tracking__referrals gray'

                switch (stage) {
                    case StagesEnum.CONFIRMED:
                    case StagesEnum.AWAITING_PATIENT_VISIT:
                        return 'referral-tracking__referrals green'

                    case StagesEnum.REFERRAL_SUBMITTED:
                    case StagesEnum.AWAITING_PROVIDER_PROPOSALS:
                    case StagesEnum.AWAITING_REFERRER_SELECTION:
                    case StagesEnum.PENDING_PROVIDER_CONFIRMATION:
                        return 'referral-tracking__referrals yellow'

                    case StagesEnum.PROPOSALS_CLOSED:
                        return 'referral-tracking__referrals purple'

                    case StagesEnum.SELECT_A_TIME_SLOT:
                    case StagesEnum.PROPOSALS_RECEIVED:
                        return 'referral-tracking__referrals blue'

                    case StagesEnum.CANCELLED_NO_PROPOSALS:
                    case StagesEnum.CANCELLED_NO_SELECTION:
                        return 'referral-tracking__referrals today'

                    case StagesEnum.PROPOSE_TIME_SLOTS:
                        return 'referral-tracking__referrals purple'

                    default:
                        return 'referral-tracking__referrals gray'
                }
            },
            formatStage(stage) {
                if (!stage) return 'N/A'

                return stage
                    .toLowerCase()
                    .split('_')
                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(' ')
            },
            getStageTooltip(request) {
                return request?.stageInfo?.nextAction
            },
            handleStageClick(request) {
                this.selectedRequestForActions = request
                const stage = request?.stageInfo?.stage
                const isPatientReferralRoute = this.$route.path.includes('/referrals-patient')
                if (isPatientReferralRoute) {
                    switch (stage) {
                        case 'PROPOSE_TIME_SLOTS':
                            this.goToProposeTime(request, this.activeReferralTab)
                    }
                }
            },
            isStageClickable(referral) {
                const stage = referral?.stageInfo?.stage
                const isPatientReferralRoute = this.$route.path.includes('/referrals-patient')

                if (isPatientReferralRoute && stage === StagesEnum.PROPOSE_TIME_SLOTS) {
                    return true
                }

                return false
            },
            getStageClasses(request) {
                return [
                    this.getStageClass(request?.stageInfo?.stage),
                    {
                        'referral-tracking__referrals-clickable': this.isStageClickable(request),
                    },
                ]
            },

            handleStageAction(request) {
                if (this.isStageClickable(request)) {
                    this.handleStageClick(request)
                }
            },
            openDetailsModal(id, sourceType) {
                this.$router.push({
                    name: 'referrals-patient.received',
                    params: {
                        sourceType: this.mapSourceTypeToUrl(sourceType),
                        id: id,
                    },
                })
            },
            closeDetailsModal(skipNavigation = false) {
                this.showViewDetailsModal = false
                this.activeRequest = {}
                this.activeSourceType = null

                if (!skipNavigation) {
                    this.$router.push({
                        name: 'referrals-patient.received',
                    })
                }
            },
            mapSourceTypeToUrl(type) {
                if (type === ReferralTrackingTypeEnum.DIRECT) return 'direct'
                if (type === ReferralTrackingTypeEnum.MATCH) return 'match'
                return type
            },
            mapSourceTypeFromUrl(type) {
                if (type === 'direct') return ReferralTrackingTypeEnum.DIRECT
                if (type === 'match') return ReferralTrackingTypeEnum.MATCH
                return type
            },
            openDirectReferralFromMatchReferal(referralId) {
                this.showViewDetailsModal = false

                this.$nextTick(() => {
                    this.openDetailsModal(referralId, 'referral')
                })
            },
            loadPatientReferralV2(append = false) {
                const userId = this.$auth.getActiveMember()?.id || this.$auth.getUser().id
                const query = {
                    limit: this.limit,
                    offset: this.offset,
                    type: 'received',
                    isFromPatient: true,
                    userId: userId,
                }
                this.isProcessing = true
                ReferralsAPI.getListV2(query).then((res) => {
                    const total = res._headers?.['x-total-count']

                    if (!append) {
                        this.patientRequests = res
                    } else {
                        this.patientRequests = [...this.patientRequests, ...res]
                    }
                    this.patientRequestsTotalCount = Number(total || 0)
                    this.isProcessing = false
                })
            },
            getTimingText(request) {
                const stageInfo = request?.stageInfo
                if (!stageInfo) return 'N/A'
                if (request?.sourceType === ReferralTrackingTypeEnum.MATCH) {
                    if (
                        request.status === ReferralStatusEnum.SCHEDULED ||
                        request.status === ReferralStatusEnum.DECLINED ||
                        request.status === ReferralStatusEnum.INACTIVE
                    )
                        return 'N/A'
                    else {
                        const totalHours = stageInfo.hoursLeft

                        if (totalHours <= 0) {
                            return 'N/A'
                        }

                        if (totalHours < 1) {
                            const minutes = Math.ceil(totalHours * 60)
                            return `${minutes} minute${minutes !== 1 ? 's' : ''} left`
                        }

                        const wholeHours = Math.floor(totalHours)
                        const days = Math.floor(wholeHours / 24)
                        const hours = wholeHours % 24

                        if (days > 0 && hours > 0) {
                            return `${days} day${days > 1 ? 's' : ''} ${hours} hour${hours > 1 ? 's' : ''} left`
                        }

                        if (days > 0) {
                            return `${days} day${days > 1 ? 's' : ''} left`
                        }

                        return `${hours} hour${hours > 1 ? 's' : ''} left`
                    }
                } else if (request?.sourceType === ReferralTrackingTypeEnum.DIRECT) {
                    return 'N/A'
                }
            },

            getTimingClass(stageInfo) {
                if (!stageInfo) return 'referral-tracking__referrals gray'

                const { urgency, hoursLeft } = stageInfo

                const isThreeHoursLeft = hoursLeft >= 0 && hoursLeft <= 3

                return {
                    'referral-tracking__referrals': true,

                    gray: hoursLeft <= 0,

                    green: urgency === UrgencyEnum.LOW && hoursLeft > 3,

                    yellow: urgency === UrgencyEnum.MEDIUM && hoursLeft > 3,

                    today: isThreeHoursLeft || ([UrgencyEnum.HIGH, UrgencyEnum.CRITICAL].includes(urgency) && hoursLeft > 3),
                }
            },
            showMore() {
                if (this.patientRequests.length >= this.patientRequestsTotalCount) return

                this.offset += this.limit
                this.loadPatientReferralV2(true)
            },
            openRescheduleModal(request) {
                this.selectedRequestForActions = request
                this.showRescheduleModal = true
            },

            closeRescheduleModal() {
                this.selectedRequestForActions = null
                this.showRescheduleModal = false
            },

            openCancellationModal() {
                this.showCancellationModal = true
            },

            closeCancellationModal() {
                this.showCancellationModal = false
            },

            openFollowUpVisitModal(request) {
                this.selectedRequestForActions = request
                this.showRescheduleModal = true
                this.followUpReferral = true
            },

            closeFollowUpVisitModal() {
                this.selectedRequestForActions = null
                this.showFollowUpVisitModal = false
                this.followUpReferral = false
            },
            handleFollowUpVisit() {
                ReferralsAPI.get(
                    this.selectedRequestForActions.id,
                    this.$auth.getActiveMember()?.id ? this.$auth.getActiveMember()?.id : this.$auth.getUser().id,
                ).then((res) => {
                    const query = {
                        userId: res.fromUser.id,
                        practiceType: res.practice.practiceType,
                        searchBy: 'zipcode',
                        insurancePlanId: res.insurancePlan.id,
                        zip: res.practiceLocation.zip,
                        physicianId: res.toUser.id,
                        practiceId: res.practice.id,
                        practiceLocationId: 0,
                        patientId: res.patient.id,
                        referralId: res.id,
                        followUpVisit: true,
                    }
                    this.$router.push({
                        name: `referrals.new.make`,
                        query: query,
                    })
                })
            },
            rescheduleAppointment() {
                this.reschedule(this.selectedRequestForActions)
            },
            cancelAppointment() {
                return ReferralsAPI.cancel(
                    this.$auth.isUserPracticeOther(),
                    this.selectedRequestForActions.id,
                    this.$auth.getActiveMember() && this.$auth.getActiveMember().id
                        ? this.$auth.getActiveMember().id
                        : this.$auth.getUser().id,
                ).then(() => {
                    this.closeCancellationModal()
                    if (this.selectedRequestForActions?.id) {
                        this.updateReferralStatus(this.selectedRequestForActions.id)
                    }
                })
            },
            cancellationModalDenyAction() {
                this.closeCancellationModal()
                if (this.isReferringPhysician) {
                    this.matchReferral(this.selectedRequestForActions)
                } else {
                    this.openRescheduleModal()
                }
            },
            matchReferral(request) {
                this.goToMatchSearchPage(request, this.$auth.getActiveMember().id)
            },
            openPatientSeenModal(request) {
                this.selectedRequestForActions = request
                this.showPatientSeenModal = true
            },
            patientSeen(event) {
                if (this.$auth.isUserPracticeDemo()) {
                    return
                }
                ReferralsAPI.updatePatientVisitStatus(this.selectedRequestForActions.id, event.status).then(() => {
                    this.showPatientSeenModal = false
                    this.loadPatientReferralV2()
                    if (event.status === 'patient-seen') {
                        this.$router.push({
                            name: `referrals.received.add-report`,
                            params: {
                                id: this.selectedReferralForActions.id,
                            },
                        })
                    }
                })
            },
            addNotesClicked(request) {
                if (request?.status === ReferralStatusEnum.COMPLETED) {
                    this.$router.push({
                        name: `referrals.received.add-report`,
                        params: {
                            id: request.id,
                        },
                    })
                    return
                }
                this.selectedRequestForActions = request
                this.isReportUploadModal = true
            },
            downloadPdf(request) {
                ReferralsAPI.get(
                    request.id,
                    this.$auth.getActiveMember()?.id ? this.$auth.getActiveMember()?.id : this.$auth.getUser().id,
                ).then((res) => {
                    this.selectedRequestForActions = res
                    this.isPrescriptionModalOpen = true
                })
            },
            closePrescriptionModal() {
                this.selectedRequestForActions = null
                this.isPrescriptionModalOpen = false
            },
            openRequestReportModal(request) {
                this.selectedRequestForActions = request
                this.showRequestReportModal = true
            },

            closeRequestReportModal() {
                this.selectedRequestForActions = null
                this.showRequestReportModal = false
            },
            requestReportSent() {
                this.reportNewRequestDateTime = dayjs().format()
                this.notificationMessage = this.$t('pages.referrals.show.details.request_sent')
                this.$refs.commonSuccessNotification.showNotification()
                this.closeRequestReportModal()
            },
            showAdditionalRecordsRequestedNotification() {
                this.closeDetailsModal()
                this.notificationMessage = this.$t('modals.patient_profile.profile.request.notification')
                this.$refs.commonSuccessNotification.showNotification()
            },
            handleDetailsModalFromRoute() {
                this.isFetching = true
                const { id, sourceType } = this.$route.params

                if (!id || !sourceType) {
                    this.showViewDetailsModal = false
                    return
                }
                this.showViewDetailsModal = true
                const actualSourceType = this.mapSourceTypeFromUrl(sourceType)

                if (this.activeRequest?.id === id && this.activeSourceType === actualSourceType) return

                this.activeSourceType = actualSourceType

                if (actualSourceType === 'referral') {
                    ReferralsAPI.get(id, this.$auth.getActiveMember()?.id || this.$auth.getUser().id)
                        .then((res) => {
                            this.activeRequest = res
                        })
                        .finally(() => (this.isFetching = false))
                } else {
                    ReferralsPoolAPI.getReferralPoolById(id, 'received', this.$auth.getActiveMember()?.id)
                        .then((res) => {
                            this.activeRequest = res
                        })
                        .finally(() => (this.isFetching = false))
                }
            },
            updateReferralStatus(referralId) {
                const index = this.patientRequests.findIndex((r) => r.id === referralId)

                if (index === -1) return

                const userId = this.$auth.getActiveMember()?.id || this.$auth.getUser().id
                const existingSourceType = this.patientRequests[index]?.sourceType
                ReferralsAPI.get(referralId, userId).then((referral) => {
                    referral.sourceType = existingSourceType
                    this.$set(this.patientRequests, index, referral)
                })
            },
            refreshMatchReferral(requestId) {
                const index = this.patientRequests.findIndex((r) => r.id === requestId)

                if (index === -1) return

                const existingSourceType = this.patientRequests[index]?.sourceType

                const request =
                    this.$auth.getPractice().practiceType === PracticeTypeEnum.PHYSICIAN
                        ? ReferralsPoolAPI.getReferralPoolById(requestId, 'received', this.$auth.getActiveMember()?.id)
                        : ReferralsPoolAPI.getReferralPoolById(requestId, 'received', null, this.$auth.getPractice()?.id)

                request.then((res) => {
                    res.sourceType = existingSourceType
                    this.$set(this.patientRequests, index, res)
                })
            },
            declineReferral(request) {
                this.isProcessing = true
                ReferralsPoolAPI.decline(request.id, {
                    referralPoolId: request.id,
                    userId: this.$auth.getActiveMember()?.id || this.$auth.getUser().id,
                    practiceId: this.$auth.getPractice()?.id,
                })
                    .then(() => {
                        this.refreshMatchReferral(request.id)
                    })
                    .finally(() => {
                        this.isProcessing = false
                    })
                    .finally(() => {
                        this.activeStatusDropdown = null
                    })
            },
            getStatusText(referral) {
                const displayStatus = this.getDisplayStatus(referral?.status, referral?.sourceType, referral?.appointmentDateTime)

                return this.$t(`pages.referrals.tracking.status_title.${displayStatus}`)
            },
            scheduledForDate(date) {
                if (!date) return ''
                return new Date(date).toLocaleDateString('en-US', {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric',
                })
            },
            isAppointmentPassed(appointmentDateTime) {
                if (!appointmentDateTime) return false
                return !dayjs().isBefore(dayjs(appointmentDateTime))
            },
            isPatientSeen(statusOrReferral, appointmentDateTime) {
                if (!statusOrReferral) return false
                const status = typeof statusOrReferral === 'object' ? statusOrReferral?.status : statusOrReferral
                const apptDate =
                    typeof statusOrReferral === 'object' ? statusOrReferral?.appointmentDateTime : appointmentDateTime

                return (
                    status === ReferralStatusEnum.PATIENT_VISIT_PAST ||
                    (status === ReferralStatusEnum.PATIENT_VISIT_PENDING && this.isAppointmentPassed(apptDate))
                )
            },
            getDisplayStatus(status, sourceType, appointmentDateTime) {
                const isPatientSeen = this.isPatientSeen(status, appointmentDateTime)

                const statusMapping = {
                    [ReferralTrackingTypeEnum.MATCH]: {
                        [ReferralStatusEnum.CREATED]: 'CREATED',
                        [ReferralStatusEnum.TIME_SLOTS_PROPOSED]: 'AWAITING_CONFIRMATION',
                        [ReferralStatusEnum.DECLINED]: 'DECLINED',
                        [ReferralStatusEnum.SCHEDULED]: 'SCHEDULED',
                        [ReferralStatusEnum.INACTIVE]: 'EXPIRED',
                    },

                    [ReferralTrackingTypeEnum.DIRECT]: {
                        [ReferralStatusEnum.PATIENT_VISIT_PENDING]: isPatientSeen ? 'PATIENT_SEEN' : 'SCHEDULED',
                        [ReferralStatusEnum.PATIENT_VISIT_PAST]: 'PATIENT_SEEN',
                        [ReferralStatusEnum.NO_SHOW]: 'NO_SHOW',
                        [ReferralStatusEnum.CANCELLED]: 'CANCELLED',
                        [ReferralStatusEnum.CONSULTATION_NOTES_PENDING]: 'UPLOAD_NOTES',
                        [ReferralStatusEnum.COMPLETED]: 'COMPLETED',
                    },
                }

                return statusMapping[sourceType]?.[status] || status
            },
            getStatusColor(referral) {
                const displayStatus = this.getDisplayStatus(referral?.status, referral?.sourceType, referral?.appointmentDateTime)

                const orangeStatuses = ['UPLOAD_NOTES']

                const yellowStatuses = ['CREATED', 'AWAITING_CONFIRMATION']

                const blueStatuses = ['SCHEDULED', 'COMPLETED']

                const redStatuses = ['DECLINED', 'CANCELLED', 'NO_SHOW', 'EXPIRED']

                const greenStatuses = ['CONSULTATION_NOTES_PENDING', 'REQUEST_NOTES', 'PATIENT_SEEN']

                if (orangeStatuses.includes(displayStatus)) return 'orange'
                if (yellowStatuses.includes(displayStatus)) return 'yellow'
                if (blueStatuses.includes(displayStatus)) return 'blue'
                if (redStatuses.includes(displayStatus)) return 'today'
                if (greenStatuses.includes(displayStatus)) return 'green'

                return 'gray'
            },
            isStatusClickable(request) {
                return request?.status === ReferralStatusEnum.CONSULTATION_NOTES_PENDING
            },
            handleStatusAction(request) {
                if (this.isStatusClickable(request)) {
                    this.addNotesClicked(request)
                }
            },
            getStatusBadgeClass(referral) {
                if (!referral) {
                    return 'referral-tracking__referrals gray'
                }

                return {
                    'referral-tracking__referrals': true,
                    'referral-tracking__status-badge': true,
                    [this.getStatusColor(referral)]: true,
                    'referral-tracking__referrals-clickable': this.isStatusClickable(referral),
                }
            },
            isStatusChangeable(request) {
                const isDirectReferral = request?.sourceType === ReferralTrackingTypeEnum.DIRECT

                if (!isDirectReferral) {
                    return false
                }

                return (
                    this.isPatientSeen(request) ||
                    [
                        ReferralStatusEnum.NO_SHOW,
                        ReferralStatusEnum.CANCELLED,
                        ReferralStatusEnum.CONSULTATION_NOTES_PENDING,
                    ].includes(request.status)
                )
            },
            handleStatusClick(request) {
                if (this.activeStatusDropdown === request.id) {
                    this.activeStatusDropdown = null
                } else {
                    this.activeStatusDropdown = request.id
                }
            },
            closeStatusDropdown() {
                this.activeStatusDropdown = null
            },
            dropdownOptions(request) {
                const { status } = request

                if (!this.isStatusChangeable(request)) {
                    return []
                }

                if (this.isPatientSeen(request)) {
                    return [
                        ReferralStatusEnum.CANCELLED,
                        ReferralStatusEnum.CONSULTATION_NOTES_PENDING,
                        ReferralStatusEnum.NO_SHOW,
                    ]
                }

                const optionsMap = {
                    [ReferralStatusEnum.NO_SHOW]: [ReferralStatusEnum.CANCELLED, ReferralStatusEnum.CONSULTATION_NOTES_PENDING],

                    [ReferralStatusEnum.CANCELLED]: [ReferralStatusEnum.NO_SHOW, ReferralStatusEnum.CONSULTATION_NOTES_PENDING],

                    [ReferralStatusEnum.CONSULTATION_NOTES_PENDING]: [ReferralStatusEnum.NO_SHOW, ReferralStatusEnum.CANCELLED],
                }

                return optionsMap[status] || []
            },
            getApiActionForStatus(referralId, selectedStatus) {
                switch (selectedStatus) {
                    case ReferralStatusEnum.NO_SHOW:
                        return {
                            api: ReferralsAPI.updatePatientVisitStatus,
                            args: [referralId, 'no-show'],
                        }

                    case ReferralStatusEnum.CONSULTATION_NOTES_PENDING:
                        return {
                            api: ReferralsAPI.updatePatientVisitStatus,
                            args: [referralId, 'patient-seen'],
                        }

                    case ReferralStatusEnum.CANCELLED:
                        return {
                            api: ReferralsAPI.cancel,
                            args: [
                                this.$auth.isUserPracticeOther(),
                                referralId,
                                this.$auth.getActiveMember() && this.$auth.getActiveMember().id
                                    ? this.$auth.getActiveMember().id
                                    : this.$auth.getUser().id,
                            ],
                        }

                    case ReferralStatusEnum.PATIENT_VISIT_PENDING:
                        return {
                            api: ReferralsAPI.accept,
                            args: [referralId],
                        }

                    default:
                        return null
                }
            },
            handleStatusChange(request, selectedStatus) {
                if (selectedStatus === ReferralStatusEnum.CANCELLED) {
                    this.selectedRequestForActions = request
                    this.openCancellationModal()
                    this.activeStatusDropdown = null
                    return
                }

                if (selectedStatus === ReferralStatusEnum.CONSULTATION_NOTES_PENDING) {
                    const action = this.getApiActionForStatus(request.id, selectedStatus)
                    if (!action) {
                        return
                    }
                    const { api, args } = action

                    api(...args)
                        .then(() => {
                            this.updateReferralStatus(request.id)
                            this.selectedRequestForActions = request
                            this.isReportUploadModal = true
                        })
                        .finally(() => {
                            this.activeStatusDropdown = null
                        })
                    return
                }

                const action = this.getApiActionForStatus(request.id, selectedStatus)
                if (!action) {
                    return
                }
                const { api, args } = action

                api(...args)
                    .then(() => {
                        this.updateReferralStatus(request.id)
                    })
                    .finally(() => {
                        this.activeStatusDropdown = null
                    })
            },
            getDropdownOptionStatus(option, sourceType) {
                if (option === ReferralStatusEnum.CONSULTATION_NOTES_PENDING) {
                    return ReferralStatusEnum.CONSULTATION_NOTES_PENDING
                }
                return this.getDisplayStatus(option, sourceType)
            },
            getDropdownStatusColor(status, sourceType = ReferralTrackingTypeEnum.DIRECT) {
                if (status === ReferralStatusEnum.CONSULTATION_NOTES_PENDING) {
                    return 'orange'
                }

                const displayStatus = this.getDisplayStatus(status, sourceType)

                if (['NO_SHOW', 'CANCELLED'].includes(displayStatus)) {
                    return 'red'
                }

                if (['UPLOAD_NOTES'].includes(displayStatus)) {
                    return 'orange'
                }

                if (['CONSULTATION_NOTES_PENDING', 'REQUEST_NOTES', 'PATIENT_SEEN'].includes(displayStatus)) {
                    return 'green'
                }

                if (['SCHEDULED', 'COMPLETED'].includes(displayStatus)) {
                    return 'blue'
                }

                return 'gray'
            },
        },
        watch: {
            '$route.params.id': {
                immediate: true,
                handler() {
                    this.handleDetailsModalFromRoute()
                },
            },
        },
        mounted() {
            this.loadPatientReferralV2()
        },
    }
</script>
